/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { clearCache } from '../fn/tenant/clear-cache';
import { ClearCache$Params } from '../fn/tenant/clear-cache';
import { createTenant } from '../fn/tenant/create-tenant';
import { CreateTenant$Params } from '../fn/tenant/create-tenant';
import { deleteTenantConfig } from '../fn/tenant/delete-tenant-config';
import { DeleteTenantConfig$Params } from '../fn/tenant/delete-tenant-config';
import { findById1 } from '../fn/tenant/find-by-id-1';
import { FindById1$Params } from '../fn/tenant/find-by-id-1';
import { findTenants } from '../fn/tenant/find-tenants';
import { FindTenants$Params } from '../fn/tenant/find-tenants';
import { getConfig } from '../fn/tenant/get-config';
import { GetConfig$Params } from '../fn/tenant/get-config';
import { inactivateTenant } from '../fn/tenant/inactivate-tenant';
import { InactivateTenant$Params } from '../fn/tenant/inactivate-tenant';
import { PaginatedDataTenantDto } from '../models/paginated-data-tenant-dto';
import { reactivateTenant } from '../fn/tenant/reactivate-tenant';
import { ReactivateTenant$Params } from '../fn/tenant/reactivate-tenant';
import { syncArgusDrugData } from '../fn/tenant/sync-argus-drug-data';
import { SyncArgusDrugData$Params } from '../fn/tenant/sync-argus-drug-data';
import { syncHexData } from '../fn/tenant/sync-hex-data';
import { SyncHexData$Params } from '../fn/tenant/sync-hex-data';
import { syncPostData } from '../fn/tenant/sync-post-data';
import { SyncPostData$Params } from '../fn/tenant/sync-post-data';
import { Tenant } from '../models/tenant';
import { TenantConfig } from '../models/tenant-config';
import { updateTenant } from '../fn/tenant/update-tenant';
import { UpdateTenant$Params } from '../fn/tenant/update-tenant';
import { updateTenantConfig } from '../fn/tenant/update-tenant-config';
import { UpdateTenantConfig$Params } from '../fn/tenant/update-tenant-config';
import { ValidationError } from '../models/validation-error';

@Injectable({ providedIn: 'root' })
export class TenantService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findById1()` */
  static readonly FindById1Path = '/api/tenants/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById1()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById1$Response(params: FindById1$Params, context?: HttpContext): Observable<StrictHttpResponse<Tenant>> {
    return findById1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findById1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById1(params: FindById1$Params, context?: HttpContext): Observable<Tenant> {
    return this.findById1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Tenant>): Tenant => r.body)
    );
  }

  /** Path part for operation `updateTenant()` */
  static readonly UpdateTenantPath = '/api/tenants/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTenant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTenant$Response(params: UpdateTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return updateTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTenant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTenant(params: UpdateTenant$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.updateTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `createTenant()` */
  static readonly CreateTenantPath = '/api/tenants/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTenant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTenant$Response(params: CreateTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return createTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTenant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTenant(params: CreateTenant$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.createTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `reactivateTenant()` */
  static readonly ReactivateTenantPath = '/api/tenants/{id}/reactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reactivateTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateTenant$Response(params: ReactivateTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reactivateTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reactivateTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateTenant(params: ReactivateTenant$Params, context?: HttpContext): Observable<void> {
    return this.reactivateTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `inactivateTenant()` */
  static readonly InactivateTenantPath = '/api/tenants/{id}/inactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inactivateTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  inactivateTenant$Response(params: InactivateTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return inactivateTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inactivateTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inactivateTenant(params: InactivateTenant$Params, context?: HttpContext): Observable<void> {
    return this.inactivateTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateTenantConfig()` */
  static readonly UpdateTenantConfigPath = '/api/tenants/{id}/configs/{key}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTenantConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTenantConfig$Response(params: UpdateTenantConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return updateTenantConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTenantConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTenantConfig(params: UpdateTenantConfig$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.updateTenantConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `deleteTenantConfig()` */
  static readonly DeleteTenantConfigPath = '/api/tenants/{id}/configs/{key}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTenantConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTenantConfig$Response(params: DeleteTenantConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTenantConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTenantConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTenantConfig(params: DeleteTenantConfig$Params, context?: HttpContext): Observable<void> {
    return this.deleteTenantConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clearCache()` */
  static readonly ClearCachePath = '/api/tenants/clear-receiver-cache/{tenantDiscr}/{instanceDiscr}';

  /**
   * Clear cache for receiver
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clearCache()` instead.
   *
   * This method doesn't expect any request body.
   */
  clearCache$Response(params: ClearCache$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return clearCache(this.http, this.rootUrl, params, context);
  }

  /**
   * Clear cache for receiver
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clearCache$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clearCache(params: ClearCache$Params, context?: HttpContext): Observable<string> {
    return this.clearCache$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `findTenants()` */
  static readonly FindTenantsPath = '/api/tenants';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findTenants()` instead.
   *
   * This method doesn't expect any request body.
   */
  findTenants$Response(params?: FindTenants$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDataTenantDto>> {
    return findTenants(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findTenants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findTenants(params?: FindTenants$Params, context?: HttpContext): Observable<PaginatedDataTenantDto> {
    return this.findTenants$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedDataTenantDto>): PaginatedDataTenantDto => r.body)
    );
  }

  /** Path part for operation `getConfig()` */
  static readonly GetConfigPath = '/api/tenants/{id}/configs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfig$Response(params: GetConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TenantConfig>>> {
    return getConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfig(params: GetConfig$Params, context?: HttpContext): Observable<Array<TenantConfig>> {
    return this.getConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TenantConfig>>): Array<TenantConfig> => r.body)
    );
  }

  /** Path part for operation `syncPostData()` */
  static readonly SyncPostDataPath = '/api/tenants/post-data';

  /**
   * API to request post data and save in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `syncPostData()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncPostData$Response(params?: SyncPostData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return syncPostData(this.http, this.rootUrl, params, context);
  }

  /**
   * API to request post data and save in the database
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `syncPostData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncPostData(params?: SyncPostData$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.syncPostData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `syncHexData()` */
  static readonly SyncHexDataPath = '/api/tenants/hex-data';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `syncHexData()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncHexData$Response(params?: SyncHexData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return syncHexData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `syncHexData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncHexData(params?: SyncHexData$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.syncHexData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `syncArgusDrugData()` */
  static readonly SyncArgusDrugDataPath = '/api/tenants/argus-drug-data';

  /**
   * API to request medicine data throw Argus system
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `syncArgusDrugData()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncArgusDrugData$Response(params?: SyncArgusDrugData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return syncArgusDrugData(this.http, this.rootUrl, params, context);
  }

  /**
   * API to request medicine data throw Argus system
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `syncArgusDrugData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncArgusDrugData(params?: SyncArgusDrugData$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.syncArgusDrugData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

}
